import {
	IModel,
	IVIPProjectBase,
	VIPProjectBase,
	VIPCertificate,
} from "@/loader";

/**
 * Project Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPProject extends IVIPProjectBase {
}

/**
 * Project Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPProject extends VIPProjectBase implements IVIPProject, IModel<IVIPProject> {
	constructor (data: IVIPProject = {}) {
		super(data);
	}

	public load(data: IVIPProject) {
		super.load(data);
	}

	public update(data: IVIPProject) {
		super.update(data);
	}

	public get workCertificate(): VIPCertificate | null {
		return this.certificates.find(c => c.isTypeWorkCertificate) || null;
	}

	public get abilityCertificate(): VIPCertificate | null {
		return this.certificates.find(c => c.isTypeAbilityCertificate) || null;
	}

	public get needPipeline(): boolean {
		return this.ips.some(pip => pip.ip?.pipeline);
	}
}
